module.exports = __webpack_public_path__ + "assets/img/section-1-part-2-pj-panda-app.bb87ee5b.png";